/**
 *
 * Description:
 * This component show AdSense for shopping ads. It's not tested to have multiple of these components on a page.
 *
 */
import React from 'react';
import AlmostRandom from 'static/script/utils/almost-random';
import GdprSettings from 'tradera-utils/gdpr-settings';
import PropTypes from 'prop-types';

class AdSense extends React.Component {
    static propTypes = {
        channel: PropTypes.string,
        searchQuery: PropTypes.string.isRequired,
        pageIndex: PropTypes.number.isRequired,
        className: PropTypes.string
    };

    static defaultProps = {
        className: ''
    };

    constructor(props) {
        super(props);
        this.state = { visible: false };
        this.containerId = `adsense-${AlmostRandom.get()}`;
        this.gdpr = GdprSettings;
    }

    componentDidMount() {
        this.loadAds();
    }

    componentDidUpdate(prevProps) {
        const { searchQuery, pageIndex } = this.props;
        if (
            searchQuery != prevProps.searchQuery ||
            pageIndex != prevProps.pageIndex
        ) {
            this.loadAds();
        }
    }

    loadAds() {
        const { searchQuery, pageIndex, channel } = this.props;
        if (searchQuery && window._googCsa) {
            const pageOptions = {
                pubId: 'pub-3205607041006869',
                query: searchQuery,
                adPage: pageIndex,
                adtest: 'off',
                personalizedAds: this.gdpr.isMarketingEnabled(),
                hl: 'sv',
                adsafe: 'medium',
                siteLinks: true,
                linkTarget: '_blank',
                channel: channel,
                adLoadedCallback: (containerName, adsLoaded) => {
                    if (this.containerId === containerName) {
                        this.setState({ visible: adsLoaded });
                    }
                }
            };
            const args = [
                'ads',
                pageOptions,
                {
                    container: this.containerId,
                    number: 3,
                    lines: 1
                }
            ];

            window._googCsa.apply(null, args);
        }
    }

    render() {
        const { className } = this.props;
        const { visible } = this.state;
        return (
            <div
                className={`${className} py-2 px-4 ${visible ? '' : 'd-none'}`}
                style={{ backgroundColor: 'white' }}>
                <div id={this.containerId} className="mx-auto" />
            </div>
        );
    }
}

export default AdSense;
